// Sales choices remain untouched. Purchasing also needs catalog presentations
// that do not yet have a branch price or complete sales configuration.
export const mergeStockPurchaseCatalog = (salesProducts = [], catalogProducts = []) => {
  const salesById = new Map(salesProducts.map((product) => [String(product.id), product]));
  return catalogProducts.map((catalogProduct) => {
    const salesProduct = salesById.get(String(catalogProduct.id));
    const salesVarieties = new Map((salesProduct?.Varieties || []).map((variety) => [String(variety.id), variety]));
    return {
      ...catalogProduct,
      ...salesProduct,
      Varieties: (catalogProduct.Varieties || []).map((catalogVariety) => {
        const salesVariety = salesVarieties.get(String(catalogVariety.id));
        const salesFormats = new Map((salesVariety?.VarietyPrices || []).map((format) => [String(format.id), format]));
        return {
          ...catalogVariety,
          ...salesVariety,
          VarietyPrices: salesVariety?.VarietyPrices || [],
          purchaseFormats: (catalogVariety.VarietyPrices || []).map((format) => ({
            ...salesFormats.get(String(format.id)),
            ...format,
            ...(!salesFormats.has(String(format.id)) ? { completion: { isReady: false } } : {}),
          })),
        };
      }),
    };
  });
};
